import {eventActionTypes} from './events.actionTypes';
const initialState = {
  ld_eventData: false,
  er_eventData: null,
  eventDetails: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case eventActionTypes.SET_EVENT_DATA_LOAD: {
      return {...state, ld_eventData: true};
    }
    case eventActionTypes.SET_EVENT_DATA: {
      return {
        ...state,
        ld_eventData: false,
        eventDetails: action.payload,
        er_eventData: null,
      };
    }
    case eventActionTypes.UPDATE_EVENT_DATA: {
      return {
        ...state,
        eventDetails: {
          ...(state?.eventDetails ?? {}),
          ...action.payload,
        },
      };
    }
    case eventActionTypes.SET_EVENT_DATA_FAIL: {
      return {
        ...state,
        ld_eventData: false,
        er_eventData: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

export {reducer as eventReducer};
